import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Profile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser =
      JSON.parse(localStorage.getItem('currentUser')) ||
      JSON.parse(localStorage.getItem('loggedInUser'));

    if (currentUser) {
      setUser(currentUser);
    } else {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('loggedInUser');
    navigate('/login');
  };

  const calculateAge = (dob) => {
    if (!dob) return 'N/A';
    const birthDate = new Date(dob);
    const diff = Date.now() - birthDate.getTime();
    const age = new Date(diff).getUTCFullYear() - 1970;
    return age;
  };

  if (!user) return null;

  return (
    <div className="container py-5">
      <div className="text-center mb-4">
        <h2 className="fw-bold">My Profile</h2>
        <p className="text-muted">Manage your personal information and account details</p>
      </div>

      <div className="card shadow p-4 mx-auto" style={{ maxWidth: '650px' }}>
        <div className="text-center">
          {user.profileImg ? (
            <img
              src={user.profileImg}
              alt="Profile"
              width="120"
              height="120"
              style={{ borderRadius: '50%', objectFit: 'cover', marginBottom: '1rem' }}
            />
          ) : (
            <div
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                backgroundColor: '#6c757d',
                margin: '0 auto 1rem auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
                color: '#fff',
              }}
            >
              {user.name?.charAt(0).toUpperCase()}
            </div>
          )}

          <h4 className="fw-bold">{user.name}</h4>
          <p className="text-muted">{user.email}</p>
        </div>

        <hr />

        <div className="row">
          <div className="col-md-6 mb-2">
            <strong>Phone:</strong> {user.phone || 'N/A'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Gender:</strong> {user.gender || 'N/A'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Date of Birth:</strong> {user.dob || 'N/A'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Age:</strong> {user.age || calculateAge(user.dob)}
          </div>
          <div className="col-md-12 mb-2">
            <strong>Address:</strong> {user.address || 'Not Provided'}
          </div>
          <div className="col-md-12 mb-2">
            <strong>Registered On:</strong>{' '}
            {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'N/A'}
          </div>
        </div>

        <div className="d-flex justify-content-between flex-wrap mt-4">
          <Link to="/cart" className="btn btn-outline-success me-2 mb-2">
            Go to Cart
          </Link>
          <Link to="/update-profile" className="btn btn-outline-primary me-2 mb-2">
            Edit Profile
          </Link>
          <button onClick={handleLogout} className="btn btn-outline-danger mb-2">
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
